import { useRef } from 'react';
import type {
  ReactElement,
  PropsWithChildren,
} from 'react';

import styled from 'styled-components';
import useOnClickOutside from 'use-onclickoutside';

export const StyledContent = styled.div(({
  theme: {
    colors,
  },
}) => ({
  borderRadius: 4,
  backgroundColor: colors.NEUTRAL_WHITE,
  boxShadow: '0px 4px 8px rgba(148, 148, 148, 0.24)',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: colors.NEUTRAL_INACTIVE,
}));

export type ContentProps = PropsWithChildren<{
  onClickOutside: (event: Event) => void;
}>;

export function Content({
  children = undefined,
  onClickOutside,
}: ContentProps): ReactElement {
  const rootRef = useRef<HTMLElement>(null);

  useOnClickOutside(rootRef, onClickOutside);

  return (
    <StyledContent
      ref={rootRef as unknown as ((instance: HTMLDivElement | null) => void)}
    >
      {children}
    </StyledContent>
  );
}
